import { Select } from "antd";
import _ from "lodash";
import QueryString from "qs";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { getConverts } from "../../../api/evaluation.api";
import { createDtttScores, createHomeworkScores, deleteParticipationScores, getAttendances, getDtttScores, getHomeworkItemOptions, getHomeworkItems, getHomeworkScores, getParticipationItemOptions, getParticipationItems, getParticipationScores, getRecords, updateDtttScores, updateHomeworkScores, updateParticipationScores } from "../../../api/tutor.api";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import useScore from "../../../hooks/useScore";
import { IClass } from "../../../models/campusClasses.model";
import { ITimetable } from "../../../models/campusClasses3.model";
import { IGetConverts } from "../../../models/evaluation.model";
import { IGetAttendances, IGetDtttScores, IGetHomeworkItems, IGetHomeworkScores, IGetParticipationItems, IGetRecordItemOptions, IGetRecords, IParticipationScoreDelete } from "../../../models/tutor.model";
import { RootState } from "../../../store/rootReducer";
import Button from "../../Button";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import DateTable from "./DateTable";
import ShowRublic1Modal from "./modals/ShowRublic1Modal";
import ShowRublic2Modal from "./modals/ShowRublic2Modal";
import ShowRublic3Modal from "./modals/ShowRublic3Modal";
import ShowRublic4Modal from "./modals/ShowRublic4Modal";
import ShowRublic5Modal from "./modals/ShowRublic5Modal";
import PbtTable from "./PbtTable";

const Block = styled.div`
  .guide {
    font-size: 14px;

    .link:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  table {
    td {
      text-align: center;
    }
  }
`;

interface IProps {
  classData: IClass|undefined;
  timetables: ITimetable[]|undefined;
  noUseQuery?: boolean;
}

const Record2: FC<IProps> = ({
  classData,
  timetables,
  noUseQuery,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // GR0001 = 평가 구분
  const GR0001 = commonCodes.find(item => item.commonCode === 'GR0001')?.detailCode;
  const { successNotification } = useNotification();
  const { handleData } = useScore();
  const { data: res, isLoading, error, execute } = useAxios<IGetRecords>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetHomeworkItems>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetAttendances>();
  const { arr: res4, isLoading: isLoading4, error: error4, executeArr: execute4 } = useAxios<any>();
  const { data: res5, isLoading: isLoading5, error: error5, execute: execute5 } = useAxios<IGetHomeworkScores>();
  const { arr: submitRes, isLoading: submitIsLoading, error: submitError, executeArr: submitExecute } = useAxios();
  const { data: res6, isLoading: isLoading6, error: error6, execute: execute6 } = useAxios<IGetParticipationItems>();
  const { data: res7, isLoading: isLoading7, error: error7, execute: execute7 } = useAxios<IGetRecordItemOptions>();
  const { arr: res8, isLoading: isLoading8, error: error8, executeArr: execute8 } = useAxios<any>();
  const { data: submitRes2, isLoading: submitIsLoading2, error: submitError2, execute: submitExecute2 } = useAxios();
  const { data: res9, isLoading: isLoading9, error: error9, execute: execute9 } = useAxios<IGetDtttScores>();
  const { data: res10, isLoading: isLoading10, error: error10, execute: execute10 } = useAxios<IGetConverts>();
  const { data: res11, isLoading: isLoading11, error: error11, execute: execute11 } = useAxios<IGetConverts>();
  const { arr: submitRes3, isLoading: submitIsLoading3, error: submitError3, executeArr: submitExecute3 } = useAxios();
  const { data: deleteRes, isLoading: deleteIsLoading, error: deleteError, execute: deleteExecute } = useAxios();

  const [timetableCode, setTimetableCode] = useState<number>();
  const [classCode, setClassCode] = useState<string>();
  const [learningTypeCode, setLearningTypeCode] = useState<string>();
  const [data, setData] = useState<any>([]);
  const [homeworkOptions, setHomeworkOptions] = useState<any>([]);
  const [homeworkScores, setHomeworkScores] = useState<any>([]);
  const [partData, setPartData] = useState<any>([]);
  const [partScores, setPartScores] = useState<any>([]);
  const [dtttData, setDtttData] = useState<any>([]);
  const [dtttStudents, setDtttStudents] = useState<any>([]);
  const [showRublic1Visible, setShowRublic1Visible] = useState<boolean>(false);
  const [showRublic2Visible, setShowRublic2Visible] = useState<boolean>(false);
  const [showRublic3Visible, setShowRublic3Visible] = useState<boolean>(false);
  const [showRublic4Visible, setShowRublic4Visible] = useState<boolean>(false);
  const [showRublic5Visible, setShowRublic5Visible] = useState<boolean>(false);
  const [hasDtttEdit, setHasDtttEdit] = useState(false);

  useEffect(() => {
    if (query.timetableCode) {
      setTimetableCode(Number(query.timetableCode));
    }
    if (query.classCode) {
      setClassCode(String(query.classCode));
    }
  }, [location]);

  useEffect(() => {
    if (classData?.classCode) {
      setClassCode(classData.classCode);
    }
  }, [classData]);

  useEffect(() => {
    if (timetableCode && learningTypeCode) {
      setData([]);
      setPartData([]);
      setDtttData([]);
      setHasDtttEdit(false);

      switch (learningTypeCode) {
        case 'HW':
          execute2(getHomeworkItems(timetableCode, learningTypeCode));
          doGetHomeworkScores();
          break;
        case 'DT':
          if (classCode) {
            doGetDtttScores();
            execute10(getConverts(1002));
            execute11(getConverts(1000));
          }
          break;
        case 'PA':
          execute6(getParticipationItems(timetableCode));
          execute7(getParticipationItemOptions());
          break;
        case 'PB':
          break;
        default:
          execute(getRecords(timetableCode, learningTypeCode));
      }
    }
  }, [timetableCode, learningTypeCode]);

  useEffect(() => {
    if (classCode && timetableCode) {
      execute3(getAttendances(classCode, timetableCode));
    }
  }, [classCode, timetableCode]);

  useEffect(() => {
    if (res && !isLoading) {
      setData(handleData(res.data));
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      setData(handleData(res2.data));

      let evaluationTypeCodes: number[] = res2.data?.map(item => item.evaluationTypeCode);
      evaluationTypeCodes = _.uniq(evaluationTypeCodes);

      const arr: any = [];
      evaluationTypeCodes.forEach(evaluationTypeCode => {
        arr.push(getHomeworkItemOptions(evaluationTypeCode));
      });
      execute4(arr);
    }
  }, [res2, isLoading2]);

  useEffect(() => {
    if (res4.length && !isLoading4) {
      const options: any = [];
      res4.forEach(item => {
        options.push({
          evaluationTypeCode: item.data?.at(0)?.evaluationTypeCode,
          data: item.data,
        });
      });
      setHomeworkOptions(options);
    }
  }, [res4, isLoading4]);

  useEffect(() => {
    if (res3 && !isLoading3 && res5 && !isLoading5 && data.length) {
      const scores: any = [];

      res3?.data?.forEach((item, index) => {
        scores.push([...Array(data.length).fill(undefined)]);
      });

      res3?.data?.forEach((item, index) => {
        // @ts-ignore
        const scoreInfo = res5?.data?.find(item2 => item2.memberCode === item.memberCode)?.studentScoreInfo;
        if (scoreInfo) scores[index] = scoreInfo;
      });

      setHomeworkScores(scores);
    }
  }, [res3, isLoading3, res5, isLoading5, data]);

  useEffect(() => {
    if (submitRes.length && !submitIsLoading) {
      doGetHomeworkScores();
      successNotification(t('common.message.save1'));
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (res6 && !isLoading6 && timetableCode) {
      setPartData(res6.data);
      doGetParticipationScores();
    }
  }, [res6, isLoading6, timetableCode]);

  useEffect(() => {
    if (res8.length && !isLoading8) {
      const scores: any = [];
      res8.forEach(item => {
        if (item.data) {
          scores.push(item.data);
        } else {
          scores.push({ studentParticipationInfo: [] });
        }
      });
      setPartScores(scores);
    }
  }, [res8, isLoading8]);

  useEffect(() => {
    if (submitRes2 && !submitIsLoading2) {
      doGetParticipationScores();
      successNotification(t('common.message.save1'));
    }
  }, [submitRes2, submitIsLoading2]);

  useEffect(() => {
    if (res9 && !isLoading9) {
      const _data: any = _.cloneDeep(res9.data.curriculums);
      _data.forEach((item: any) => {
        item.key = `${item.prdCurriculumCode}${item.activityCode}`
      });
      setDtttData(handleData(_data));

      const _students: any = _.cloneDeep(res9.data.students);
      _students.forEach((item1: any) => {
        item1.details.forEach((item2: any) => {
          item2.key = `${item2.prdCurriculumCode}${item2.activityCode}`;
          const curriculum = _data.find((item3: any) => item3.key === item2.key);
          item2.evaluatorTypeCode = curriculum?.evaluatorTypeCode;
          item2.scaleTypeCode = curriculum?.scaleTypeCode;
          item2.semesterSeqEvaluationCode = curriculum?.semesterSeqEvaluationCode;
        });
      });
      setDtttStudents(_students);
    }
  }, [res9, isLoading9]);

  useEffect(() => {
    if (submitRes3.length && !submitIsLoading3) {
      doGetDtttScores();
      successNotification(t('common.message.save1'));
    }
  }, [submitRes3, submitIsLoading3]);

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      doGetParticipationScores();
      successNotification(t('common.message.delete'));
    }
  }, [deleteRes, deleteIsLoading]);

  const doGetHomeworkScores = () => {
    if (!timetableCode) return;
    execute5(getHomeworkScores(timetableCode));    
  }

  const doGetDtttScores = () => {
    if (timetableCode && classCode)
      execute9(getDtttScores(timetableCode, classCode));
  }

  const doGetParticipationScores = () => {
    if (!timetableCode) return;
    let classTimeSeqs: any = res6?.data?.map(item => item.classTimeSeq);
    classTimeSeqs = _.uniq(classTimeSeqs);

    const arr: any = [];
    classTimeSeqs.forEach((classTimeSeq: any) => {
      arr.push(getParticipationScores(timetableCode, classTimeSeq));
    });
    execute8(arr);
  }

  const renderData = () => {
    switch (learningTypeCode) {
      case 'HW':
        return res3?.data?.map((item: any, index: number) => (
          <tr key={index}>
            <td>{item.studentKorName} ({item.studentEngName})</td>
            {[...Array(data.length)].map((subitem, subindex) => (
              <td key={subindex}>
                <Select
                  className="w-100"
                  placeholder={t('common.button.select')}
                  // @ts-ignore
                  value={homeworkScores.at(index)?.at(subindex)?.evaluationConversionCode || getHomeworkDefaultValue(res2?.data?.at(subindex)?.evaluationTypeCode, homeworkScores.at(index)?.at(subindex)?.evaluationConversionCode)}
                  // @ts-ignore
                  onChange={value => onSetHomeworkScore(index, subindex, value)}
                >
                  {/* @ts-ignore */}
                  {getHomeworkOptions(res2?.data?.at(subindex)?.evaluationTypeCode)}
                </Select>
              </td>
            ))}
          </tr>
        ));
      default:
        return res3?.data?.map((item: any, index: number) => (
          <tr key={index}>
            <td>{item.studentKorName} ({item.studentEngName})</td>
            {[...Array(data.length)].map((element, subindex) => (
              <td
                style={{ backgroundColor: getStudentScore(subindex, item.memberCode) === 'N/A' ? 'gainsboro' : ''}}
                key={subindex}
              >
                {getStudentScore(subindex, item.memberCode) === 'N/A' ? '' : getStudentScore(subindex, item.memberCode)}
              </td>
            ))}
          </tr>
        ));
    }
  }

  const getStudentScore = (subindex: number, memberCode: string) => {
    const student = data.at(subindex)?.studentsInfo?.find((item: any) => item.memberCode === memberCode);

    if (!student) return 'N/A';
    if (student.score === null) return 'X';

    return Math.round(student.score);
  }

  const getHomeworkDefaultValue = (evaluationTypeCode: number|undefined, evaluationConversionCode: number|undefined) => {
    if (evaluationTypeCode === 1000 && !evaluationConversionCode) {
      return homeworkOptions.find((item: any) => item.evaluationTypeCode === 1000)?.data?.at(0)?.evaluationConversionCode;
    }

    return undefined;
  }

  const getHomeworkOptions = (evaluationTypeCode?: number) => {
    if (!evaluationTypeCode) return null;

    const options = homeworkOptions.find((item: any) => item.evaluationTypeCode === evaluationTypeCode);
    if (options) {
      return options.data?.map((item: any) => (
        <Select.Option
          key={item.evaluationConversionCode}
          value={item.evaluationConversionCode}
        >
          {item.evaluationInput}
        </Select.Option>
      ))
    }

    return null;
  }

  const onSetHomeworkScore = (index: number, subindex: number, value: number) => {
    const scores: any = _.cloneDeep(homeworkScores);
    if (scores.at(index)?.at(subindex)?.evaluationConversionCode) {
      scores[index][subindex].evaluationConversionCode = value;
    } else {
      scores[index][subindex] = {
        evaluationConversionCode: value,
      };
    }
    setHomeworkScores(scores);
  }

  const onHomeworkSubmit = () => {
    if (!timetableCode) return;

    const createReq: any = [];
    const updateReq: any = [];

    homeworkScores.forEach((item: any, index: number) => {
      item.forEach((subitem: any, subindex: number) => {
        // @ts-ignore
        const defaultValue = getHomeworkDefaultValue(res2?.data?.at(subindex)?.evaluationTypeCode, homeworkScores.at(index)?.at(subindex)?.evaluationConversionCode);
        if (!subitem && defaultValue) {
          subitem = {
            evaluationConversionCode: defaultValue,
          }
        }

        if (subitem) {
          // @ts-ignore
          subitem.semesterSeqEvaluationCode = res2?.data?.at(subindex)?.semesterSeqEvaluationCode;
          // @ts-ignore
          subitem.memberCode = res3?.data?.at(index)?.memberCode;
          // @ts-ignore
          subitem.classStudentCode = res3?.data?.at(index)?.classStudentCode;  
        }

        if (subitem?.scoreCode) {
          updateReq.push(subitem);
        } else if (subitem) {
          createReq.push(subitem);
        }
      });
    });

    const arr: any = [];
    if (createReq.length) {
      arr.push(createHomeworkScores(timetableCode, createReq));
    }
    if (updateReq.length) {
      arr.push(updateHomeworkScores(timetableCode, updateReq));
    }
    if (arr.length) {
      submitExecute(arr);
    }
  }

  const getPartScore = (index: number, memberCode: string) => {
    const item = partScores?.at(index)?.studentParticipationInfo?.find((item: any) => item?.memberCode === memberCode);
    return item?.evaluationConversionCode;
  }

  const onSetPartScores = (index: number, memberCode: string, value: number) => {
    const scores: any = _.cloneDeep(partScores);
    const item = scores?.at(index)?.studentParticipationInfo?.find((item: any) => item?.memberCode === memberCode);
    if (item?.evaluationConversionCode && !item?.isNew) {
      item.evaluationConversionCode = value;
      item.isNew = false;
    } else {
      const item = {
        evaluationConversionCode: value,
        memberCode,
        isNew: true,
      };
      scores[index].studentParticipationInfo.push(item);
    }
    setPartScores(scores);
  }

  const isPartDisabled = (memberCode: string) => {
    const student = res3?.data?.find((item: any) => item.memberCode === memberCode);
    if (!student?.attendStatus || student?.attendStatus === 'AB' || student?.attendStatus === 'NT') {
      return true;
    }

    return false;
  }

  const onPartSubmit = () => {
    const req: any = [];
  
    // default 값 처리
    partScores.forEach((item: any, index: number) => {
      res3?.data?.forEach((student: any) => {
        const value = getPartScore(index, student.memberCode);
        if (!value) {
          const newItem = {
            // @ts-ignore
            evaluationConversionCode: res7?.data?.at(4)?.evaluationConversionCode,
            memberCode: student.memberCode,
            isNew: true,
          };
          item.studentParticipationInfo.push(newItem);
        }
      });
    });

    partScores.forEach((item: any, index: number) => {
      item.studentParticipationInfo.forEach((subitem: any) => {
        subitem.timetableCode = timetableCode;
        subitem.classTimeSeq = index + 1;
        req.push(subitem);
      });
    });

    if (req.length) {
      submitExecute2(updateParticipationScores(req));
    }
  }

  const onPartDelete = (memberCode: string) => {
    if (!res6?.data || !timetableCode) return;

    const req: IParticipationScoreDelete[] = [];
    res6?.data?.forEach((item: any) => {
      req.push({
        classTimeSeq: item.classTimeSeq,
        memberCode,
      });
    });

    deleteExecute(deleteParticipationScores(timetableCode, req));
  }

  const getDtttScore = (memberCode: string, key: string, required: string = 'score') => {
    const student = dtttStudents.find((item: any) => item.memberCode === memberCode);
    if (student) {
      const detail = student.details.find((item: any) => item.key === key);
      if (detail) {
        if (required === 'score') {
          return detail?.score || (detail.score === 0 ? 0 : 'X');
        } else {
          return detail.evaluationConversionCode;
        }
      }
    }

    return 'N/A';
  }

  const onSetDtttConversionCode = (memberCode: string, key: string, value: number) => {
    const students: any = _.cloneDeep(dtttStudents);
    const student = students.find((item: any) => item.memberCode === memberCode);
    if (student) {
      const detail = student.details.find((item: any) => item.key === key);
      if (detail) {
        detail.evaluationConversionCode = value;
      }
    }
    setDtttStudents(students);
  }

  const renderDtttCell = (memberCode: string, key: string) => {
    const evaluatorTypeCode = dtttData.find((item: any) => item.key === key)?.evaluatorTypeCode;

    switch (evaluatorTypeCode) {
      case 'MS':
        return getDtttScore(memberCode, key);
      case 'TC':
        {
          const scaleTypeCode = dtttData.find((item: any) => item.key === key)?.scaleTypeCode;
          
          if (scaleTypeCode && !hasDtttEdit) {
            setHasDtttEdit(true);
          }

          if (scaleTypeCode === 'YN') {
            return (
              <Select
                placeholder={t('common.button.select')}
                value={getDtttScore(memberCode, key, 'evaluationConversionCode')}
                onChange={value => onSetDtttConversionCode(memberCode, key, value)}
                >
                {res11?.data?.map((item: any, index: number) => (
                  <Select.Option
                    key={index}
                    value={item.conversionCode}
                  >
                    {item.evaluationInput}
                  </Select.Option>
                ))}
              </Select>
            );
          } else if (scaleTypeCode === 'SC') {
            return (
              <Select
                placeholder={t('common.button.select')}
                // @ts-ignore
                value={getDtttScore(memberCode, key, 'evaluationConversionCode') || res10?.data?.at(4)?.conversionCode}
                onChange={value => onSetDtttConversionCode(memberCode, key, value)}
              >
                {res10?.data?.map((item: any, index: number) => (
                  <Select.Option
                    key={index}
                    value={item.conversionCode}
                  >
                    {item.evaluationInput}
                  </Select.Option>
                ))}
              </Select>
            );
          }
        }
    }

    return null;
  }

  const onDtttSubmit = () => {
    if (!timetableCode) return;

    const createReq: any = [];
    const updateReq: any = [];

    dtttStudents.forEach((item1: any) => {
      item1.details.forEach((item2: any) => {
        if (item2.evaluatorTypeCode === 'TC') {
          // 조건을 충족하는 경우 디폴트값 3 적용
          if (item2.scaleTypeCode === 'SC' && !item2.evaluationConversionCode) {
            // @ts-ignore
            item2.evaluationConversionCode = res10?.data?.at(4)?.conversionCode;
          }
          item2.classStudentCode = res3?.data?.find(o => o.memberCode = item1.memberCode)?.classStudentCode;

          if (item2.evaluationConversionCode) {
            if (item2.resultCode) updateReq.push(item2);
            else createReq.push(item2);  
          }
        }
      });
    });

    const arr: any = [];
    if (createReq.length) {
      arr.push(createDtttScores(timetableCode, createReq));
    }
    if (updateReq.length) {
      arr.push(updateDtttScores(timetableCode, updateReq));
    }
    if (arr.length) {
      submitExecute3(arr);
    }
  }

  return (
    <>
      {isLoading || isLoading2 || isLoading3 || isLoading4 || isLoading5 || isLoading6 || isLoading7 || isLoading8 || isLoading9 || isLoading10 || isLoading11 || submitIsLoading || submitIsLoading2 || submitIsLoading3 || deleteError ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={error5} />
      <ErrorResponse error={error6} />
      <ErrorResponse error={error7} />
      <ErrorResponse error={error8} />
      <ErrorResponse error={error9} />
      <ErrorResponse error={error10} />
      <ErrorResponse error={error11} />
      <ErrorResponse error={submitError} />
      <ErrorResponse error={submitError2} />
      <ErrorResponse error={submitError3} />
      <ErrorResponse error={deleteError} />

      <DateTable
        classData={classData}
        timetables={timetables}
        timetableCode={timetableCode}
        setTimetableCode={setTimetableCode}
        noUseQuery={noUseQuery}
      />

      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={learningTypeCode}
              onChange={value => setLearningTypeCode(value)}
            >
              {GR0001?.map((item: any) => {
                return (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                )
              })}
            </Select>
          </div>
        </div>
      </div>

      {
        (learningTypeCode === 'PP' ||
        learningTypeCode === 'RV' ||
        learningTypeCode === 'HW') &&
        data.length
          ? (
            <>
              <Block className="comm-table__area line-type">
                <table>
                  <colgroup>
                    {[...Array((data.length || 0) + 1)].map((item, index) => (
                      <col key={index} width="200px" />
                    ))}
                  </colgroup>
                  <thead>
                    <tr>
                      <th rowSpan={3} />
                      {data.map((item: any, index: number) => {
                        if (item.colSpan !== 0)
                          return <th key={index} colSpan={item.colSpan}>{item.depth1Name}</th>;
                        else
                          return null;
                      })}
                    </tr>
                    {
                      learningTypeCode === 'HW'
                      // Homework는 depth2와 subject의 순서를 바꿔서 표시
                        ? (
                          <>
                            <tr>
                              {data.map((item: any, index: number) => (
                                <th key={index}>{item.subjectName}</th>
                              ))}
                            </tr>
                            <tr>
                              {data.map((item: any, index: number) => (
                                <th key={index}>{item.depth2Name}</th>
                              ))}
                            </tr>
                          </>
                          )
                        : (
                          <>
                            <tr>
                              {data.map((item: any, index: number) => (
                                <th key={index}>{item.depth2Name}</th>
                              ))}
                            </tr>
                            <tr>
                              {data.map((item: any, index: number) => (
                                <th key={index}>{item.subjectName}</th>
                              ))}
                            </tr>
                          </>
                          )
                    }
                  </thead>
                  <tbody>
                    {renderData()}
                    
                  </tbody>
                </table>
              </Block>
              {learningTypeCode === 'HW' && (  
                <div className="comm-bx__space">
                  <div className="comm-btn__area right">
                  <Button
                    onClick={onHomeworkSubmit}
                    className="btn-basic pink"
                    text={t('common.button.save')}
                  />
                  </div>
                </div>
              )}
            </>
            )
            // rendering participation
          : learningTypeCode === 'PA' && partData.length
            ? (
              <>
                <Block className="comm-table__area line-type">
                  <table>
                    <colgroup>
                      {[...Array((partData.length || 0) + 1)].map((item, index) => (
                        <col key={index} />
                      ))}
                    </colgroup>
                    <thead>
                      <tr>
                        <th />
                        {partData.map((item2: any, index2: number) => (
                          <th key={index2}>{item2.classTimeSeq}{t('class.class.18')}</th>
                        ))}
                        <th>{t('common.button.delete')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {res3?.data?.map((item2: any, index2: number) => (
                        <tr key={index2}>
                          <td>{item2.studentKorName} ({item2.studentEngName})</td>
                          {[...Array(partData.length)].map((item3, index3) => (
                            <td key={index3}>
                              <Select
                                className="w-100"
                                placeholder={t('common.button.select')}
                                // @ts-ignore
                                value={getPartScore(index3, item2.memberCode) || res7?.data?.at(4)?.evaluationConversionCode}
                                onChange={value => onSetPartScores(index3, item2.memberCode, value)}
                                disabled={isPartDisabled(item2.memberCode)}
                              >
                                {/* @ts-ignore */}
                                {res7?.data?.map((item: any) => (
                                  <Select.Option
                                    key={item.evaluationConversionCode}
                                    value={item.evaluationConversionCode}
                                  >
                                    {item.evaluationInput}
                                  </Select.Option>
                                ))}
                              </Select>
                            </td>
                          ))}
                          <td>
                            <div className="comm-btn__area justify-content-center">
                              <Button
                                onClick={() => onPartDelete(item2.memberCode)}
                                className="btn-basic small gray"
                                text={t('common.button.delete')}
                              />                          
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Block>
                <div className="comm-bx__space">
                  <div className="comm-btn__area right">
                    <Button
                      onClick={onPartSubmit}
                      className="btn-basic pink"
                      text={t('common.button.save')}
                    />
                  </div>
                </div>
              </>
              )
              // rendering dttt
            : learningTypeCode === 'DT' && dtttData.length
              ? (
                <>
                  <Block>
                    <div className="comm-bx__between">
                      <div className="guide sub-title">
                        [GUIDE]&nbsp;
                          <span
                            className="link"
                            onClick={() => setShowRublic1Visible(true)}
                          >
                            Rubric 1
                          </span> /&nbsp;
                          <span
                            className="link"
                            onClick={() => setShowRublic2Visible(true)}
                          >
                            Rubric 2
                          </span> /&nbsp;
                          <span
                            className="link"
                            onClick={() => setShowRublic3Visible(true)}
                          >
                            Rubric 3
                          </span> /&nbsp;
                          <span
                            className="link"
                            onClick={() => setShowRublic4Visible(true)}
                          >
                            Rubric 4
                          </span> /&nbsp;
                          <span
                            className="link"
                            onClick={() => setShowRublic5Visible(true)}
                          >
                            Rubric 5
                          </span>
                      </div>
                    </div>
                    <div className='comm-table__area line-type mt-0'>
                      <table>
                        <colgroup>
                          {[...Array((dtttData.length || 0) + 1)].map((item, index) => (
                            <col key={index} width="200px" />
                          ))}
                        </colgroup>
                        <thead>
                          <tr>
                            <th rowSpan={3} />
                            {dtttData.map((item: any, index: number) => {
                              if (item.colSpan !== 0)
                                return <th key={index} colSpan={item.colSpan}>{item.depth1Name}</th>;
                              else
                                return null;
                            })}
                          </tr>
                          <tr>
                            {dtttData.map((item: any, index: number) => (
                              <th key={index}>{item.subjectName}</th>
                            ))}
                          </tr>
                          <tr>
                            {dtttData.map((item: any, index: number) => (
                              <th key={index}>{item.depth2Name}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {dtttStudents?.map((item1: any, index1: number) => (
                            <tr key={index1}>
                              <td>{item1.memberName} ({item1.memberEngName})</td>
                              {dtttData.map((item2: any, index2: number) => (
                                <td
                                  key={index2}
                                  style={{
                                    backgroundColor: renderDtttCell(item1.memberCode, item2.key) === 'N/A'
                                      ? 'gainsboro'
                                      : ''
                                  }}
                                >
                                  {
                                    renderDtttCell(item1.memberCode, item2.key) === 'N/A'
                                      ? ''
                                      : renderDtttCell(item1.memberCode, item2.key)
                                  }
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Block>
                  {hasDtttEdit && (
                    <div className="comm-bx__space">
                      <div className="comm-btn__area right">
                        <Button
                          onClick={onDtttSubmit}
                          className="btn btn-primary btn-w150p"
                          text={t('common.button.save')}
                        />
                      </div>
                    </div>
                  )}
                </>
                )
              : learningTypeCode === 'PB'
                ? (
                  <PbtTable
                    timetableCode={timetableCode}
                    classCode={classCode}
                    attendances={res3?.data}
                  />
                )
                : null
      }

      {showRublic1Visible &&
        <ShowRublic1Modal
          visible={showRublic1Visible}
          setVisible={setShowRublic1Visible}
        />
      }
      {showRublic2Visible &&
        <ShowRublic2Modal
          visible={showRublic2Visible}
          setVisible={setShowRublic2Visible}
        />
      }
      {showRublic3Visible &&
        <ShowRublic3Modal
          visible={showRublic3Visible}
          setVisible={setShowRublic3Visible}
        />
      }
      {showRublic4Visible &&
        <ShowRublic4Modal
          visible={showRublic4Visible}
          setVisible={setShowRublic4Visible}
        />
      }
      {showRublic5Visible &&
        <ShowRublic5Modal
          visible={showRublic5Visible}
          setVisible={setShowRublic5Visible}
        />
      }
    </>
  );
}

export default Record2;
